import authenticationService from '../services/authentication.service';
import {SetBearerToken} from '../services/axios.service';

const token = JSON.parse(localStorage.getItem('token'));
if (token) SetBearerToken(token);

const authentication = {
    namespaced: true,
    state: {
        status: {loggedIn: !!token},
        accessCrud: null,
        roles: null,
        userRoles: null
    },
    actions: {
        async getAccess({commit, state, getters}) {
            if (state.accessCrud === null) {
                var response = await authenticationService.GetAccess();
                commit('setAccessCrud', response.data);
            }
            return getters.accessCrud;
        },
        async getRoles({commit, state, getters}) {
            if (state.roles === null) {
                var response = await authenticationService.GetRoles();
                var accessCrud  = await this.dispatch(
                    "authentication/getAccess"
                );

//                response.data.splice(response.data.findIndex(x => x.value == "SystemAdmin"),1);
                if(!accessCrud.some(x => x.e && x.e == "Admin"))
                response.data.find(x => x.value == "Admin").disabled = true;

                commit('setRoles', response.data);
            }
            return getters.roles;
        },
        async getUserRoles({commit, state, getters}) {
            if (state.userRoles === null) {
                var response = await authenticationService.GetUserRoles();
                commit('setUserRoles', response.data);
            }
            return getters.userRoles;
        },
        login({commit}, token) {
            return authenticationService
                .login(token)
                .then(
                    (token) => {
                        if (token) {
                            localStorage.setItem('token', JSON.stringify(token));
                            SetBearerToken(token);
                            commit('loginSuccess', token);
                        }
                        return Promise.resolve(token);
                    },
                    (error) => {
                        commit('loginFailure');
                        return Promise.reject(error);
                    }
                );
        },
        logout({commit}) {
            localStorage.removeItem('token');
            SetBearerToken(null);
            commit('logout');
        },
        register({commit}, user) {
            return authenticationService.register(user).then(
                (response) => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                (error) => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
    },
    getters: {
        isLoggedIn: (state) => state.status.loggedIn,
        accessCrud: (state) => state.accessCrud,
        roles: (state) => state.roles,
        userRoles: (state) => state.userRoles,
    },
    mutations: {
        setRoles(state, roles) {
            state.roles = roles;
        },
        setUserRoles(state, userRoles) {
            state.userRoles = userRoles;
        },
        setAccessCrud(state, cruds) {
            state.accessCrud = cruds;
        },
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
    },
};

export default authentication;
